var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgArrowLeft = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.83331 8C2.83331 7.72386 3.05717 7.5 3.33331 7.5H12.6666C12.9428 7.5 13.1666 7.72386 13.1666 8C13.1666 8.27614 12.9428 8.5 12.6666 8.5H3.33331C3.05717 8.5 2.83331 8.27614 2.83331 8Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.35353 2.97994C8.5488 3.1752 8.5488 3.49179 8.35353 3.68705L4.04042 8.00016L8.35353 12.3133C8.5488 12.5085 8.5488 12.8251 8.35353 13.0204C8.15827 13.2156 7.84169 13.2156 7.64643 13.0204L2.97976 8.35372C2.7845 8.15845 2.7845 7.84187 2.97976 7.64661L7.64643 2.97994C7.84169 2.78468 8.15827 2.78468 8.35353 2.97994Z",
    fill: "black"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgArrowLeft, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/R-PANELv6.5-RC1/arrow_left.8b4a563c.svg";
export { ForwardRef as ReactComponent };